module.exports = __webpack_public_path__ + "img/qr-mark.35d8670.png";